import React, { Component } from "react";

const PortfolioList = [
    {
        image: 'image-1',
        category: 'Internet de las Cosas',
        title: 'Plataforma diseñada para la empresa Tecal'
    },
    {
        image: 'image-2',
        category: 'Infraestructura de red',
        title: 'Ampliación de red realizada en AllTic'
    },
    {
        image: 'image-3',
        category: 'Infraestructura de red',
        title: 'Diseño e instalación de red para el Teatro Calima'
    },
]

class Portfolio extends Component{
    render(){
        const {column } = this.props;
        const list = PortfolioList.slice(0 , this.props.item);
        return(
            <React.Fragment>
                {list.map((value , index) => (
                    <div className={`${column}`} key={index}>
                        <div className="Tilt-inner">
                            <div className="portfolio">
                                <div className="thumbnail-inner">
                                    <div className={`thumbnail ${value.image}`}></div>
                                    <div className={`bg-blr-image ${value.image}`}></div>
                                </div>
                                <div className="content">
                                    <div className="inner">
                                        <p>{value.category}</p>
                                        <h4 className="color-white">{value.title}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
               
            </React.Fragment>
        )
    }
}
export default Portfolio;